import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { PermissionGuard } from './permission.guard';

@Injectable()
export class KYCKYBPermissionGuard extends PermissionGuard {
    canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean> {
        // If they only have an expiry date, it means they are blocked.
        // It should be fine to check this before checking the permissions.
        const isUserBlocked =
            this.auth.account.personaCompletedAt === null && this.auth.account.personaExpiresAt !== null;

        if (isUserBlocked) {
            return Promise.resolve(true);
        }

        return super.canActivate(route, _state);
    }
}
